export default "__VITE_ASSET__06PCLzjP__"